import { useKeenSlider } from 'keen-slider/react';
import 'keen-slider/keen-slider.min.css';
import { useWindowSize } from 'usehooks-ts';
import { useEffect, useState } from 'react';
import Navigation from '@atoms/Navigation';
import Character from '@molecules/item/Character';
import { useTranslation } from 'react-i18next';

function CharacterSlide({ count, data }) {
  const { width } = useWindowSize();

  const [loaded, setLoaded] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [perview, setPerview] = useState(count);

  const sliderOptions = {
    initial: 0,
    created(slider) {
      setLoaded(true);
    },
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel);
    },
    loop: true,
    rubberband: false,
    slides: { origin: 'center', perView: perview, spacing: 0 },
  };
  const [sliderRef, internalSlider] = useKeenSlider(sliderOptions);
  useEffect(() => {
    if (data.length <= count) setPerview(data.length - 0.5);
    internalSlider.current?.update();
    internalSlider.current?.moveToIdx(0);
    setCurrentSlide(0);
  }, [data, perview, internalSlider.current]);

  return (
    <div className="bg-[#f8f8f8] min-h-[300px] text-center">
      <div
        ref={sliderRef}
        className={`keen-slider mask  bts-container max-w-[1200px]  m-auto grid grid-cols-3 sm:grid-cols-4 overflow-hidden`}
      >
        {data.map((props, index) => {
          return (
            <div
              key={`index-${index}`}
              className={` keen-slider__slide overflow-hidden text-center  ${
                currentSlide === index && data.length > 3 ? 'active' : ''
              }`}
            >
              <Character
                category={props.category}
                title={props.title}
                articleNo={props.idx}
                idx={index + 1}
              />
            </div>
          );
        })}
      </div>
      {loaded && internalSlider.current && data.length > 2 && (
        <Navigation
          current={currentSlide + 1}
          totalPage={data.length}
          leftOnClick={e =>
            e.stopPropagation() || internalSlider.current?.prev()
          }
          lefttDisabled={false}
          rightOnClick={e =>
            e.stopPropagation() || internalSlider.current?.next()
          }
          rightDisabled={false}
        />
      )}
    </div>
  );
}

export default CharacterSlide;
